import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ApiFragment } from '../../core/records/entities/api-fragment.class';
import { Identifier } from '../../core/records/entities/metadata/metadata.entity';

@Injectable({ providedIn: 'root' })
export abstract class AbstractRecordsStateService {
    public abstract setRecordsLoading(loading: boolean): void;

    public abstract getRecordsLoading(): Observable<boolean>;

    public abstract getRecordsError(): Observable<boolean>;

    public abstract setRecordsError(error: boolean): void;

    public abstract getRecords(ids: Identifier[]): Observable<(ApiFragment | undefined)[]>;

    public abstract getDefinedRecords(ids: Identifier[]): Observable<ApiFragment[]>;

    public abstract addRecords(records: ApiFragment[]): void;

    public abstract getRecord(ids: Identifier): Observable<ApiFragment | undefined>;

    public abstract addRecord(record: ApiFragment): void;
}
